export default __webpack_public_path__ + "static/media/Baby10.bc5552e2.gif";